import request from '@/router/axios';
//故障推送开关项目列表
export const projectInfosWithPushSwitch = (data) => {
  return request({
    url: '/svolt-ess-boss-service/parameter/projectInfosWithPushSwitch',
    method: 'get',
    params: data
  })
}
//人员树状列表
export const userInfosWithPushSwitch = (data) => {
  return request({
    url: '/svolt-ess-boss-service/parameter/userInfosWithPushSwitch',
    method: 'get',
    params: data
  })
}
//保存推送开关人员
export const updateUserStatusWithPushSwitchsForProject = (data) => {
  return request({
    url: '/svolt-ess-boss-service/parameter/updateUserStatusWithPushSwitchsForProject',
    method: 'post',
    data: data
  })
}

//推送开关更改状态-多个
export const updateStatusWithPushSwitchs = (data) => {
  return request({
    url: '/svolt-ess-boss-service/parameter/updateStatusWithPushSwitchs',
    method: 'post',
    data: data
  })
}
//推送开关更改状态-单个
export const updateStatusWithPushSwitch = (data) => {
  return request({
    url: '/svolt-ess-boss-service/parameter/updateStatusWithPushSwitch',
    method: 'post',
    data: data
  })
}
export default{
  projectInfosWithPushSwitch,
  updateUserStatusWithPushSwitchsForProject,
  userInfosWithPushSwitch,
  updateStatusWithPushSwitch,
  updateStatusWithPushSwitchs
}



// WEBPACK FOOTER //
// ./src/api/parameter.js